import type { ApiResponse } from '../../../../../lib/api';
import { apiRequest } from '../../../../../lib/api-utils';
import { API_ENDPOINTS } from '../../../../../lib/constants';

export async function copyAutomationTemplate(
  id: string,
  params: { customName: string; customDescription: string },
): Promise<{ created: boolean; templateId: string | null }> {
  const response = await apiRequest<
    ApiResponse<{
      created: boolean;
      templateId: string | null;
    }>
  >(API_ENDPOINTS.AUTOMATION_TEMPLATES.COPY(id), {
    method: 'POST',
    body: JSON.stringify(params),
  });
  return response.data;
}
